import { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import './CursorBlob.css';

function CursorBlob() {
  const x = useMotionValue(typeof window !== 'undefined' ? window.innerWidth / 2 : 0);
  const y = useMotionValue(typeof window !== 'undefined' ? window.innerHeight / 2 : 0);

  const smoothX = useSpring(x, { stiffness: 40, damping: 18, mass: 0.7 });
  const smoothY = useSpring(y, { stiffness: 40, damping: 18, mass: 0.7 });

  useEffect(() => {
    const onMove = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [x, y]);

  return (
    <motion.div
      className="cursor-blob"
      style={{
        translateX: smoothX,
        translateY: smoothY,
      }}
      aria-hidden="true"
    />
  );
}

export default CursorBlob;
